import React from "react";
import WelcomeContainer from "../../containers/WelcomeContainer/WelcomeContainer";

type PageProps = {
  whatever: string;
};
export default function WelcomePage(props: PageProps) {
  return (
    <>
      <div>
        <WelcomeContainer></WelcomeContainer>
      </div>
    </>
  );
}
